import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { findProvinceFromAddress } from 'src/app/helpers/find-province-from-address.helper';
import { CustomSale, CustomSaleFulFillmentStatus, CustomSaleFulFillmentStatusAux, CustomSalePaymentStatus, CustomSalePaymentStatusAux } from 'src/app/models/custom-sale.schema';
import { TimePeriods } from 'src/app/models/delivery.schema';
import { Partner } from 'src/app/models/partner.schema';
import { Product } from 'src/app/models/product.schema';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { PartnerService } from 'src/app/services/partner.service';
import { ProductService } from 'src/app/services/product.service';
import { ShopifySaleService } from 'src/app/services/shopify-sale.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { DeliveryLinkDialogComponent } from '../delivery-link-dialog/delivery-link-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomPaymentsService } from 'src/app/services/custom-payments.service';
import { Customer } from 'src/app/models/customer.schema';
import { CustomersService } from 'src/app/services/customers.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-custom-sales-form',
  templateUrl: './custom-sales-form.component.html',
  styleUrls: ['./custom-sales-form.component.scss']
})
export class CustomSalesFormComponent implements OnInit {

  formValidationMsgs;
  customSaleForm: any;
  partners: Partner[];
  products: Product[];
  initialPartners: Partner[];
  initialProducts: Product[];
  customVendita: any;
  selectedVariant: any;
  selectedVariants: any[] = [];
  showProductVariant: boolean[] = [];
  selectedProductsForVariants: any[] = [];
  showNonUniqueProductPartner: boolean[] = [];
  customSalePaymentStatus = CustomSalePaymentStatus;
  customSalePaymentStatusAux = CustomSalePaymentStatusAux;
  customSaleFulfillmentStatus = CustomSaleFulFillmentStatus;
  customSaleFulfillmentStatusAux = CustomSaleFulFillmentStatusAux;
  isLoading: boolean = false;
  disabledBtn: boolean = false;
  timePeriods = TimePeriods;
  deliveryFTime: any;
  deliveryTTime: any;
  deliveryFTimeError: boolean = false;
  deliveryTTimeError: boolean = false;
  newCustomer: boolean = false;
  customers: Customer[] = [];
  selectedPartnerIds: number[] = [];
  previewUrls: { [key: number]: string | SafeUrl } = {};
  productId: string|number;
  platform: string;
  showAddressModal: boolean = false;
  selectedPartner: Partner | null = null;
  selectedPickupAddress: string | null = null;
  selectedPickupAddresses: { [key: number]: string } = {};
  isConfirming: boolean = false;
  pendingPartnerChangeIndex: number | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private partnerService: PartnerService,
    private productService: ProductService,
    private spinnerService: SpinnerService,
    private commanUsesService: CommanUsesService,
    private shopifySaleService: ShopifySaleService,
    public dialog: MatDialog,
    private CustomPaymentsService: CustomPaymentsService,
    private customersService: CustomersService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
  ) { 
    this.formValidationMsgs = CustomSale.validationMessages;
  }
  
  async ngOnInit() {
    try {
      this.spinnerService.show();
      this.cdr.detectChanges();
      this.customSaleForm = new FormGroup(CustomSale.validation());
      await this.loadNecessaryData();
      const platform: string = this.route.snapshot.paramMap.get('platform');
      const saleId: string = this.route.snapshot.paramMap.get('id');
      this.route.queryParams.subscribe((params) => {
        this.productId = params['productId'];
        this.platform = params['platform'];
        if(this.platform && this.productId) {
          const selectedProduct = this.initialProducts.find(product => product.id === Number(this.productId));
          this.customSaleForm.controls.platform.setValue(this.platform);
          this.handleProductChange(0, selectedProduct.id);
        }
      });
      if (saleId && platform) {
        try {
          // let res = await this.shopifySaleService.getOne(saleId);
          let res = await this.shopifySaleService.findCustomSale(saleId, platform);
          if(!res) {
            this.router.navigateByUrl("/404", { skipLocationChange: true });  
          }
          this.customVendita = res;
        }
        catch(error) {
          console.log("ERROR", error);
          this.router.navigateByUrl("/404", { skipLocationChange: true });
        }
      }
      this.customVendita ? this.patch() : (this.customVendita = new CustomSale());
      this.spinnerService.hide();
    } catch (error) {
      console.log("ERROR", error);
      let errorMessage = error?.message || 'Something went wrong';
      this.commanUsesService.showSnackBar(errorMessage);
      this.spinnerService.hide();
    }
  }

  patch(){
    [
      'firstName',
      'lastName', 
      'address', 
      'phone', 
      'total', 
      'paymentStatus', 
      'fullFillmentStatus', 
      'deliveryMethod', 
      'notes', 
      'deliveryDate',
      'deliveryTime',
      'intercom', 
      'senderName', 
      'senderSurname', 
      'senderPhone',
      'totalShippingAmount',
      'totalPrice',
      'totalLineItemsPrice',
      'customSalePaymentStatus',
      'isFlexbleDeliveryTime',
      'existingCustomer',
      'platform',
    ].forEach((param) => {
      if (this.customVendita[param] instanceof Date) {
        this.customSaleForm.controls[param].setValue(new DatePipe('it-IT').transform(this.customVendita[param], 'yyyy-MM-dd'));
      } else {
        this.customSaleForm.controls[param].setValue(this.customVendita[param]);
      }
    });

    if (this.customVendita.province) {
      this.customSaleForm.controls.province.setValue(this.customVendita.province);
      this.filterPartnersByProvince(this.customVendita.province);
    }

    if(this.customVendita?.existingCustomer){
      this.customSaleForm.get('existingCustomer')?.setValue(true);
      this.customSaleForm.get('customer')?.setValue(Number(this.customVendita.customer));
    }
    
    if(this.customVendita?.isFlexbleDeliveryTime){
      this.patchDeliveryFlexbleTime();
    }

    const control = this.customSaleForm.get('deliveryProducts') as FormArray;
    control.clear();

    let products: any[] = [];

    try {
      products = this.customVendita.customSaleLineItems ? JSON.parse(this.customVendita.customSaleLineItems) : [];
    } catch {}

    products.forEach((item: any, index: number) => {
      const patchedGroup = this.patchValues(item.product ?? item, index);
      control.push(patchedGroup);

      const productId                         = item.product?.id || item.id;
      const selectedProduct                   = this.initialProducts.find(p => p.id == productId);
      const variants                          = selectedProduct?.productVariants || [];

      this.selectedProductsForVariants[index] = selectedProduct;
      this.selectedVariants[index]            = item.product?.productVariant || null;
      this.showProductVariant[index]          = variants.length > 0;
      this.showNonUniqueProductPartner[index] = !selectedProduct?.uniqueProduct;

      if (item.product?.pickupAddress) {
        this.selectedPickupAddresses[index] = item.product.pickupAddress;
      }

      if (item.product?.productVariant) {
        // this.onVariantSelect(index, selectedProduct?.productVariants?.find(v => v.id === item.product?.productVariant?.id));
        let variant = selectedProduct?.productVariants?.find(v => v.id === Number(item.product?.productVariant?.id));
        this.selectedVariants[index] = variant;
        const deliveryProducts = this.customSaleForm.get('deliveryProducts') as FormArray;
        const deliveryGroup = deliveryProducts.at(index) as FormGroup;
        deliveryGroup.get('productVariant')?.setValue(variant.id);
        
        let totalVenditaPrice = 0;
        let totalPublicPrice = 0;

        deliveryProducts.controls.forEach((group: FormGroup) => {
          const productGroup = group.get('product') as FormGroup;
          const price = Number(productGroup.get('productPrice')?.value || 0);
          const publicPrice = Number(productGroup.get('productPublicPrice')?.value || 0);

          totalVenditaPrice += isNaN(price) ? 0 : price;
          totalPublicPrice += isNaN(publicPrice) ? 0 : publicPrice;
        });

        this.customSaleForm.patchValue({
          totalPrice: totalVenditaPrice.toFixed(2),
          totalLineItemsPrice: totalPublicPrice.toFixed(2),
        }, { emitEvent: false });
      }
    });

    //this.updateAllTotals();
  }

  patchDeliveryFlexbleTime(){
    let [startTime, endTime] = this.customVendita.deliveryTime.split("-");
    this.deliveryFTime = startTime;
    this.deliveryTTime = endTime;
  }

  patchValues(deliveryProduct: any, index: number): FormGroup {
    const formGroup = CustomSale.productFormGroup();
    const productGroup = formGroup.get('product') as FormGroup;
    let publicPrice = deliveryProduct?.productVariant && deliveryProduct?.productVariant?.variantShopifyPrice ? Number(deliveryProduct?.productVariant?.variantShopifyPrice) || 0 : Number(deliveryProduct?.productPublicPrice) || 0
    productGroup.patchValue({
      id: deliveryProduct?.id || '',
      quantity: deliveryProduct?.quantity || 1,
      productPrice: deliveryProduct?.productPrice || deliveryProduct?.amount || 0,
      productNote: deliveryProduct?.productNote || '',
      productPublicPrice: publicPrice || 0,
      hiddenProduct: deliveryProduct?.hiddenProduct ? deliveryProduct?.hiddenProduct : false,
      productImage: deliveryProduct?.productImage ? deliveryProduct?.productImage : null,
      partner:
        deliveryProduct?.partner?.id ||
        deliveryProduct?.partner ||
        null,
    });
    this.handlePartnerChange(index, deliveryProduct?.partner?.id || deliveryProduct?.partner || null);

    /*
    formGroup.get('productVariant')?.setValue(
      deliveryProduct?.productVariant?.id || deliveryProduct?.productVariant || null
    );
    */

    return formGroup;
  }

  async loadNecessaryData() {
    try {
      [this.partners, this.products, this.customers] = await Promise.all([
        this.partnerService.getAllActivePartnersForDelivery().then(res => res.partners),
        this.productService.getAllActiveProductsForDelivery().then(res => res.products),
        this.customersService.getAllCustomer(undefined, undefined, { 'User.surname': 'ASC', 'User.name': 'ASC' })
      ]);
      this.initialProducts = this.products;
      this.initialPartners = this.partners;
      this.partners = this.initialPartners.filter((partner) =>
        partner.partnerServices.some((pService) =>
          pService?.service?.pricingModel?.toLowerCase() === 'sales'
        )
      );
    } catch {}
  }

  isOptionDisabled(item: any): boolean {
    let hasEmptyId = false;
    for (const products of this.customSaleForm.value.deliveryProducts) {
      if (products.product.id === item.id) {
        hasEmptyId = true;
      }
    }
    return hasEmptyId;
  }

  async getAddress(place: any) {
    if (!this.customSaleForm) return;
    this.customSaleForm.controls.address.touched = true;
    this.customSaleForm.controls.address.setValue(place.formatted_address || place.name || '');
    this.customSaleForm.controls.latitude.setValue(place.geometry?.location?.lat() || '');
    this.customSaleForm.controls.longitude.setValue(place.geometry?.location?.lng() || '');
    let province: string = findProvinceFromAddress(place);
    if(!province) {
      this.commanUsesService.showSnackBar("Province is not found with filled address, Please enter the address again.");
      return false;
    }
    this.filterPartnersByProvince(province);
    this.customSaleForm.controls.province.setValue(province);
  }

  filterPartnersByProvince(province: string){

    this.partners = this.initialPartners.filter((partner) =>
      partner.partnerProvinces.some((partnerProvince) =>
        partnerProvince?.province?.provinceCode?.toLowerCase() === province?.toLowerCase()
      ) &&
      partner.partnerServices.some((pService) =>
        pService?.service?.pricingModel?.toLowerCase() === 'sales'
      )
    );

    /*
    console.log("this.initialPartners", this.initialPartners);
    console.log("this.partners", this.partners);
    */

  }

  directions(event: Event) {
    event.preventDefault();
    window.open(`https://www.google.com/maps/dir//${this.customSaleForm.controls.address.value}`, '_blank');
  }

  async onSubmit() {
    this.disabledBtn = true;
    let sale: any = (new FormGroupToObject()).transform(this.customSaleForm);
    let lineItems = new Array();
    let customSaleLineItems = new Array();
    for(let product of sale.deliveryProducts){
      lineItems.push(product);
    }
    sale.lineItems = JSON.stringify(lineItems);
    sale.customSale = true;
    sale.status = 'New';

    lineItems.map((item, index) => {
      const productId = item?.product?.id;
      const variantId = item?.productVariant ? Number(item.productVariant) : null;
      const product: Product | undefined = this.initialProducts.find(p => p?.id === productId);
      const productVariant = variantId && product
        ? product?.productVariants?.find(v => v?.id === variantId)
        : null;
      customSaleLineItems.push({
        product: {
          id: product?.id,
          name: product?.name || '',
          amount: product?.shopifyPrice || 0,
          image: product?.image || '',
          productImage: item?.product?.productImage ? item?.product?.productImage : null,
          quantity: item?.product?.quantity || 1,
          productPrice: item?.product?.productPrice || 0,
          productPublicPrice: item?.product?.productPublicPrice || 0,
          productNote: item?.product?.productNote || '',
          productOptionTitle: product?.productOptionTitle || null,
          hiddenProduct: item?.product?.hiddenProduct || false,
          productVariant: productVariant 
            ? {
              id: productVariant?.id,
              variantName: productVariant?.variantName || null,
              variantPrice: productVariant?.variantPrice || 0,
              variantShopifyPrice: item?.product?.productPublicPrice || 0
            } : null,
          partner: item?.product?.partner || null,
          pickupAddress: this.selectedPickupAddresses[index] || null,
        }
      })
    });
    sale.customSaleLineItems = JSON.stringify(customSaleLineItems);

    // console.log("sale.customSaleLineItems ", JSON.parse(sale.customSaleLineItems))
    // console.log("sale", sale);
    // return;
    let promiseResult: any;
    if(this.customVendita.id) {
      promiseResult = this.shopifySaleService.updateCustomSale(this.customVendita.id, sale, sale.platform);
    } else {
      promiseResult = this.shopifySaleService.create(sale);
    }
    promiseResult.then(async (res: any) => {
      if(res){

        if (!this.customVendita?.id && res?.id) {
          await this.uploadPendingImagesAfterSaleCreate(res.id);
        }

        this._snackBar.open(`La nuova vendita viene creata con Id ` + res.id, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        }).afterDismissed().subscribe(async (result) => {

          // await this.uploadProductImages(res.id);
          
          if(this.customVendita.id) {
            this.customVendita = res;
            this.patch();
            this.disabledBtn = false;
          } else {
            this.router.navigate([`/custom/sales/edit/${res?.platform}`, res?.id]);
            this.disabledBtn = false;
          }
        });
      } else{
        this.disabledBtn = false;
        this._snackBar.open(`Qualcosa è andato storto`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        }).afterDismissed().subscribe(result => {
          this.router.navigate(['/all/vendita']);
        });
      }
    }).catch((err: any) => {
      this.disabledBtn = false;
      console.log('err :>> ', err);
    })
  }

  async uploadProductImages(saleId: number) {
    const formData = new FormData();

    // Loop through each product and upload the images
    for (let i = 0; i < this.customSaleForm.get('deliveryProducts')?.value.length; i++) {
      const product = this.customSaleForm.get('deliveryProducts').value[i];
      const productId = product.product.id;
      const imageFile = product.product.productImage;

      // If there is an image for this product, append it to FormData
      if (imageFile) {
        formData.append('images', imageFile);

        // Optionally, send the productId and saleId to associate the image with the correct product
        formData.append('productId', productId.toString());
        formData.append('saleId', saleId.toString());
      }
    }

    let promiseResult = await this.shopifySaleService.uploadCustomSaleImages(formData);
    console.log("promiseResult", promiseResult);

  }

  getErrorMessages(): string[] {
    const errorMessages: string[] = [];

    const collectErrors = (control: AbstractControl, controlName: string = '') => {
      if (control instanceof FormGroup) {
        Object.keys(control.controls).forEach(key => {
          collectErrors(control.get(key)!, controlName ? `${controlName}.${key}` : key);
        });
      } else if (control instanceof FormArray) {
        control.controls.forEach((arrayControl, index) => {
          collectErrors(arrayControl, `${controlName}[${index}]`);
        });
      } else if (control && control.errors) {
        // 🔹 Normalize nested keys
        let keyPath = controlName
          .replace(/\[\d+\]/g, '') // remove array indexes [0], [1], etc.
          .replace(/^deliveryProducts\./, '') // remove prefix
          .trim();

        // Keep last 2 segments for clarity (e.g., product.id)
        const key = keyPath.includes('.') ? keyPath.split('.').slice(-2).join('.') : keyPath;

        if (!errorMessages.includes(key)) {
          errorMessages.push(key);
        }
      }
    };

    collectErrors(this.customSaleForm);
    return errorMessages;
  }

  translateErrorMessage(error: string): string {
    const messages: { [key: string]: string } = {
      firstname:                    'Nome destinatario obbligatorio',
      lastname:                     'Cognome destinatario obbligatorio',
      address:                      'Indirizzo obbligatorio o non valido',
      deliverydate:                 'Data di consegna obbligatoria',
      intercom:                     'Citofono obbligatorio',
      deliverytime:                 'Fascia oraria di consegna obbligatoria',
      senderphone:                  'Telefono mittente non valido',
      sendersurname:                'Cognome mittente obbligatorio',
      sendername:                   'Nome mittente obbligatorio',
      province:                     'Provincia obbligatoria',
      totalshippingamount:          'Costo consegna obbligatorio o non valido',
      totalprice:                   'Totale vendita obbligatorio o non valido',
      totallineitemsprice:          'Prezzo pubblico obbligatorio o non valido',
      receiveremail:                'Email destinatario non valida',
      phone:                        'Telefono destinatario non valido',
      platform:                     'La piattaforma è richiesta.',
      'product.id':                 'Selezionare un prodotto',
      'product.quantity':           'Quantità prodotto obbligatoria o non valida',
      'product.productprice':       'Prezzo prodotto obbligatorio o non valido',
      'product.productpublicprice': 'Prezzo pubblico prodotto obbligatorio o non valido',
      'product.partner':            'Selezionare un partner per il prodotto',
      'customer':                   'Selezionare un cliente esistente',
    };

    const normalized = error.toLowerCase();
    return messages[normalized] || `Campo obbligatorio: ${error.toUpperCase()}`;
  }

  async generatePaymentLink() {
    try {
      this.isLoading = true;
      const customSale = await this.CustomPaymentsService.createCheckoutSession(this.customVendita.id, this.customVendita?.platform);
      if(customSale?.customSalePaymentStatus === CustomSalePaymentStatus.paid) {
        alert('Il pagamento per questa vendita è già stato effettuato.');
        return;
      }

      this.dialog.open(DeliveryLinkDialogComponent, { width: '80vw', data: { delivery: customSale, type: 'paymentlink' } });
    } catch (error) {
      let errMsg = error?.error?.message || 'Something went wrong';
      this.commanUsesService.showSnackBar(errMsg);
    } finally {
      this.isLoading = false;
    }
  }

  handleDeliveryFlexbleTime() {
    if(this.customSaleForm.controls.isFlexbleDeliveryTime.value){
      this.deliveryFTimeError = !this.deliveryFTime;
      this.deliveryTTimeError = !this.deliveryTTime;
    }
    if(this.deliveryFTime && this.deliveryTTime){
      let time = this.deliveryFTime + "-" + this.deliveryTTime;
      this.customSaleForm.controls.deliveryTime?.setValue(time);
    }
  }

  handleExistingCustomer(event: any) {
    this.updateValidator(event.target.checked);
  }

  updateValidator(status: boolean) {
    if (status) {
      this.customSaleForm.get('customer').setValidators(Validators.required);
      this.newCustomer = false;
    } else {
      this.customSaleForm.get('customer').clearValidators();
    }
    this.customSaleForm.get('customer').updateValueAndValidity();
  }

  handleCustomerChange(customerId: any) {
    let customer: Customer = this.customers.find(c => c.id == customerId);
    if(customer){
      this.customSaleForm.controls.lastName.setValue(customer?.user?.surname || '');
      this.customSaleForm.controls.firstName.setValue(customer?.user?.name || '');
      this.customSaleForm.controls.receiverEmail.setValue(customer?.user?.email || '');
      this.customSaleForm.controls.phone.setValue(customer?.phone || '');
      this.customSaleForm.controls.intercom.setValue(customer?.intercom || '');
    } else {
      this.customSaleForm.controls.lastName.setValue('');
      this.customSaleForm.controls.firstName.setValue('');
      this.customSaleForm.controls.phone.setValue('');
      this.customSaleForm.controls.intercom.setValue('');
    }
  }

  addProduct() {
    const deliveryProducts = this.customSaleForm.get('deliveryProducts') as FormArray;
    deliveryProducts.push(CustomSale.productFormGroup());
    const newIndex = deliveryProducts.length - 1;
    this.selectedProductsForVariants[newIndex] = null;
    this.selectedVariants[newIndex] = null;
    this.showProductVariant[newIndex] = false;
    this.showNonUniqueProductPartner[newIndex] = false;
    this.updateProductTotals(newIndex);
  }

  removeProduct(index: number) {
    const deliveryProducts = this.customSaleForm.get('deliveryProducts') as FormArray;
    if (deliveryProducts.length === 1) return;
    deliveryProducts.removeAt(index);
    this.selectedProductsForVariants.splice(index, 1);
    this.selectedVariants.splice(index, 1);
    this.showProductVariant.splice(index, 1);
    this.showNonUniqueProductPartner.splice(index, 1);
    deliveryProducts.controls.forEach((_, i) => this.updateProductTotals(i));

    const updatedPickups: { [key: number]: string } = {};
    Object.keys(this.selectedPickupAddresses).forEach(key => {
      const i = Number(key);
      if (i < index) updatedPickups[i] = this.selectedPickupAddresses[i];
      else if (i > index) updatedPickups[i - 1] = this.selectedPickupAddresses[i];
    });
    this.selectedPickupAddresses = updatedPickups;
  }

  onVariantSelect(index: number, variant: any) {
    this.selectedVariants[index] = variant;
    const deliveryProducts = this.customSaleForm.get('deliveryProducts') as FormArray;
    const deliveryGroup = deliveryProducts.at(index) as FormGroup;
    deliveryGroup.get('productVariant')?.setValue(variant.id);
    this.updateProductTotals(index)
  }

  handleProductChange(index: number, productId: any) {
    const selectedProduct                   = this.initialProducts.find(p => p?.id == Number(productId));
    const variants                          = selectedProduct?.productVariants || [];
    this.selectedProductsForVariants[index] = selectedProduct;
    this.showNonUniqueProductPartner[index] = !selectedProduct?.uniqueProduct;
    this.showProductVariant[index]          = variants.length > 0;
    this.selectedVariants[index]            = variants.length > 0 ? variants[0] : null;
    const deliveryProducts                  = this.customSaleForm.get('deliveryProducts') as FormArray;
    const productGroup                      = deliveryProducts.at(index).get('product') as FormGroup;
    const partnerControl                    = productGroup.get('partner');
    const variantControl                    = (deliveryProducts.at(index) as FormGroup).get('productVariant');
    productGroup.get('id')?.setValue(selectedProduct?.id);

    const existingImage = productGroup.get('productImage')?.value;
    if (selectedProduct?.image) {
      productGroup.get('productImage')?.setValue(selectedProduct.image);
    } else {
      productGroup.get('productImage')?.setValue(null);
    }

    if (selectedProduct?.image && !this.previewUrls[index]) {
      this.previewUrls[index] = selectedProduct.image;
    }

    if (selectedProduct) {
      /*
      let partnerId = selectedProduct.uniqueProduct ? selectedProduct?.partner?.id || null : null;
      productGroup.patchValue({ partner: partnerId });
      */

      if (variants.length > 0) {
        variantControl?.setValue(variants[0].id);
      } else {
        variantControl?.reset();
      }

      /*
      if (!selectedProduct.uniqueProduct) {
        partnerControl?.setValidators([Validators.required]);
      } else {
        partnerControl?.clearValidators();
      }
      partnerControl?.updateValueAndValidity();
      */
    }
    this.updateProductTotals(index);
  }

  handleProductQuantityChange() { 
    const deliveryProducts = this.customSaleForm.get('deliveryProducts') as FormArray;
    deliveryProducts.controls.forEach((_, index) => this.updateProductTotals(index));
  }

  private updateProductTotals(index: number) {
    const deliveryProducts  = this.customSaleForm.get('deliveryProducts') as FormArray;
    const productGroup      = deliveryProducts.at(index).get('product') as FormGroup;
    const quantity          = Number(productGroup.get('quantity')?.value || 1);
    const selectedProduct   = this.selectedProductsForVariants[index];
    const selectedVariant   = this.selectedVariants[index]; 

    if (!selectedProduct) return;

    const price = selectedVariant
      ? Number(selectedVariant?.variantPrice || 0)
      : Number(selectedProduct?.price || 0);

    const publicPrice = selectedVariant
      ? Number(selectedVariant?.variantShopifyPrice || 0)
      : Number(selectedProduct?.shopifyPrice || 0);

    productGroup.patchValue({
      productPrice: price.toFixed(2),
      productPublicPrice: publicPrice.toFixed(2)
    }, { emitEvent: false });

    this.updateAllTotals();
  }

  public updateAllTotals() {
    const deliveryProducts = this.customSaleForm.get('deliveryProducts') as FormArray;
    let totalVenditaPrice = 0;
    let totalPublicPrice = 0;

    deliveryProducts.controls.forEach((group: FormGroup) => {
      const productGroup = group.get('product') as FormGroup;
      const price = Number(productGroup.get('productPrice')?.value || 0);
      const hiddenProduct = productGroup.get('hiddenProduct')?.value;
      const publicPrice = Number(productGroup.get('productPublicPrice')?.value || 0);
      const quantity = Number(productGroup.get('quantity')?.value || 1);

      if (!hiddenProduct) {
        totalVenditaPrice += price * quantity;
        totalPublicPrice += publicPrice * quantity;
      }
    });

    const shippingPrice = Number(this.customSaleForm.get('totalShippingAmount')?.value || 0);
    const totalPrice = Number(totalVenditaPrice) + Number(shippingPrice);
    this.customSaleForm.patchValue({
      totalPrice: totalVenditaPrice.toFixed(2),
      totalLineItemsPrice: totalPublicPrice.toFixed(2),
      total: totalPrice.toFixed(2),
    }, { emitEvent: false });
  }

  handlePartnerChange(index: number, partnerId: number) {
    this.selectedPartnerIds[index] = partnerId;
  }

  getPartnerPickupAddresses(index: number): string[] {
    const partnerId = this.selectedPartnerIds[index];
    if (!partnerId) return [];
    const partner = this.partners.find(p => p.id === partnerId);
    return partner?.pickupAddresses || [];
  }

  openPickupAddressModal(index: number) {
    const partnerId = this.selectedPartnerIds[index];
    const partner = this.partners.find(p => p.id === partnerId);
    if (!partner) return;

    this.selectedPartner = partner;
    this.pendingPartnerChangeIndex = index;
    // Pre-select previously chosen address if any
    this.selectedPickupAddress = this.selectedPickupAddresses[index] || null;
    this.showAddressModal = true;
  }

  handleModalBox() {
    this.showAddressModal = false;
    this.selectedPartner = null;
    this.selectedPickupAddress = null;
    this.pendingPartnerChangeIndex = null;
  }

  confirmCustomPickUpAddress() {
    if (!this.selectedPickupAddress || this.pendingPartnerChangeIndex === null) return;
    
    this.isConfirming = true;
    const index = this.pendingPartnerChangeIndex;

    // Save per-index
    this.selectedPickupAddresses[index] = this.selectedPickupAddress;

    // Also store in the form control if you have pickupAddress in productGroup
    const deliveryProducts = this.customSaleForm.get('deliveryProducts') as FormArray;
    const productGroup = deliveryProducts.at(index).get('product') as FormGroup;
    productGroup.get('pickupAddress')?.setValue(this.selectedPickupAddress);

    this.isConfirming = false;
    this.handleModalBox();
  }

  get deliveryProducts() {
    return this.customSaleForm.get('deliveryProducts') as FormArray;
  }

  async onImageSelected(event: any, index: number) {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      this.commanUsesService.showSnackBar('Formato file non valido. Carica solo JPG, JPEG o PNG.');
      event.target.value = '';
      return;
    }

    const blobUrl = URL.createObjectURL(file);
    this.previewUrls[index] = this.sanitizer.bypassSecurityTrustUrl(blobUrl);

    const formData = new FormData();
    formData.append('image', file);

    if (this.customVendita?.id) {
      formData.append('id', this.customVendita?.id);
      formData.append('platform', this.customVendita?.platform);
      formData.append('productIndex', index.toString());
      const promiseResult = await this.shopifySaleService.uploadCustomSaleImages(formData);
      const imageUrl = promiseResult.imageUrl || promiseResult.url;
      this.customSaleForm.get(['deliveryProducts', index, 'product', 'productImage'])?.setValue(imageUrl);
    } else {
      this.customSaleForm.get(['deliveryProducts', index, 'product', 'productImage'])?.setValue(file);
    }
  }



  getImageUrl(imagePath: any): string {
    if (!imagePath) return '';

    if (imagePath instanceof File) {
      return URL.createObjectURL(imagePath); 
    }

    if (typeof imagePath === 'string' && imagePath.startsWith('http')) {
      return imagePath;
    }

    return '';
  }

  async removeImage(index: number) {
    const imagePath = this.customSaleForm.get(['deliveryProducts', index, 'product', 'productImage'])?.value;

    // 🧹 revoke blob URL if exists
    if (this.previewUrls[index]) {
      const safeUrl = this.previewUrls[index] as unknown as { changingThisBreaksApplicationSecurity: string };
      const blobUrl = safeUrl.changingThisBreaksApplicationSecurity;
      URL.revokeObjectURL(blobUrl);
      delete this.previewUrls[index];
    }

    if (this.customVendita?.id && imagePath && typeof imagePath === 'string') {
      const body = { productIndex: index, imagePath, platform: this.customVendita?.platform };
      await this.shopifySaleService.deleteCustomSaleImage(this.customVendita.id, body);
    }

    this.customSaleForm.get(['deliveryProducts', index, 'product', 'productImage'])?.setValue(null);
  }


  async uploadPendingImagesAfterSaleCreate(createdSaleId: number) {
    const deliveryProducts = this.customSaleForm.value.deliveryProducts;
    for (let i = 0; i < deliveryProducts.length; i++) {
      const imageFile = deliveryProducts[i].product.productImage;
      if (imageFile && imageFile instanceof File) {
        const formData = new FormData();
        formData.append('image', imageFile);
        formData.append('id', createdSaleId.toString());
        formData.append('platform', this.customSaleForm.value.platform?.toLowerCase());
        formData.append('productIndex', i.toString());
        const result = await this.shopifySaleService.uploadCustomSaleImages(formData);
        const imageUrl = result.imageUrl || result.url;
        this.customSaleForm.get(['deliveryProducts', i, 'product', 'productImage'])?.setValue(imageUrl);
      }
    }
  }

  updateHiddenProduct(i: number, checked: boolean) {
    this.customSaleForm.get(['deliveryProducts', i, 'product', 'hiddenProduct'])?.setValue(checked);
    if (!checked) {
      this.customSaleForm.get(['deliveryProducts', i, 'product', 'hiddenProduct'])?.setValue(false);
    }
    this.updateAllTotals();
  }

  isHiddenProductDisabled(i: number): boolean {
    const totalProducts = this.customSaleForm.get('deliveryProducts')?.controls.length;
    if (totalProducts === 1) {
      this.customSaleForm.get(['deliveryProducts', i, 'product', 'hiddenProduct'])?.disable();
      return true; 
    }
    const checkedCount = this.customSaleForm.get('deliveryProducts')?.controls.filter((control: any) => 
      control.get('product.hiddenProduct')?.value === true
    ).length;

    if (checkedCount >= totalProducts - 1 && !this.customSaleForm.get(['deliveryProducts', i, 'product', 'hiddenProduct'])?.value) {
      this.customSaleForm.get(['deliveryProducts', i, 'product', 'hiddenProduct'])?.disable();
      return true;
    } else {
      this.customSaleForm.get(['deliveryProducts', i, 'product', 'hiddenProduct'])?.enable();
      return false;
    }
  }
}
